import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Badge.module.css";
const toneSolidSuffix = {
    neutral: "neutralSolid",
    accent: "accentSolid",
    success: "successSolid",
    warning: "warningSolid",
    danger: "dangerSolid",
    info: "infoSolid",
};
const dotClass = {
    neutral: styles.dotNeutral ?? "",
    accent: styles.dotAccent ?? "",
    success: styles.dotSuccess ?? "",
    warning: styles.dotWarning ?? "",
    danger: styles.dotDanger ?? "",
    info: styles.dotInfo ?? "",
};
const toneOutlineSuffix = {
    neutral: "outlineNeutral",
    accent: "outlineAccent",
    success: "outlineSuccess",
    warning: "outlineWarning",
    danger: "outlineDanger",
    info: "outlineInfo",
};
/**
 * Badge / chip do Azim CRM.
 * Suporta tons semânticos, variante soft/solid e ponto de status.
 */
export function Badge({ children, tone = "neutral", icon, soft = true, dot = false, size = "md", outline = false, className, }) {
    const toneClass = outline
        ? (styles[toneOutlineSuffix[tone]] ?? "")
        : soft
            ? (styles[tone] ?? "")
            : (styles[toneSolidSuffix[tone]] ?? "");
    const cls = [styles.badge, styles[size], toneClass, className ?? ""]
        .filter(Boolean)
        .join(" ");
    const iconSz = size === "sm" ? 13 : 14;
    return (_jsxs("span", { className: cls, children: [dot && _jsx("span", { className: `${styles.dot} ${dotClass[tone]}`, "aria-hidden": "true" }), icon && _jsx(Icon, { name: icon, size: iconSz }), children] }));
}
//# sourceMappingURL=Badge.js.map